import * as routes from './routes';
import store from './modules';

/* eslint-disable */
export {
  routes,
  store,
};



// WEBPACK FOOTER //
// ./src/modules/Faq/index.js